module.exports = __webpack_public_path__ + "static/media/16_insideyourblood.54ceed05.jpg";